import { action } from 'typesafe-actions';

import { IKnoOrganisationFunction } from 'APIPackage/AccountModule/interfaces/IKnoOrganisationFunction';
import { IPageChecklistTemplate } from 'APIPackage/AccountModule/interfaces/IPageChecklistTemplate';
import { IPageRequirementsTemplate } from 'APIPackage/AccountModule/interfaces/IPageRequirementsTemplate';
import { IUserOrganisationsResponse } from 'APIPackage/AccountModule/interfaces/IUserOrganisationsResponse';
import { IFetchChecklistTemplatesParams } from 'APIPackage/AccountModule/services/checklistTemplatesApi';
import { IFetchRequirementTemplatesParams } from 'APIPackage/AccountModule/services/requirementTemplatesApi';

import { AccountActionsEnum } from '../enums/AccountActionsEnum';

export type IAccountChecklistTemplatesGetParams = IFetchChecklistTemplatesParams & {
  isCaching: boolean;
};

export type IAccountRequirementTemplatesGetParams = IFetchRequirementTemplatesParams & {
  isCaching: boolean;
};

interface IAccountKnoOrganizationFunctionsGetParams {
  knoOrganizationId: string;
  isCaching: boolean;
}

export const accountChecklistTemplatesGet = (params: IAccountChecklistTemplatesGetParams) =>
  action(AccountActionsEnum.ACCOUNT_CHECKLIST_TEMPLATES_GET, { params });
export const accountChecklistTemplatesGetRequest = (params: IFetchChecklistTemplatesParams) =>
  action(AccountActionsEnum.ACCOUNT_CHECKLIST_TEMPLATES_GET_REQUEST, { params });
export const accountChecklistTemplatesGetSuccess = (
  params: IFetchChecklistTemplatesParams,
  data: IPageChecklistTemplate,
) =>
  action(AccountActionsEnum.ACCOUNT_CHECKLIST_TEMPLATES_GET_SUCCESS, {
    params,
    data,
  });
export const accountChecklistTemplatesGetFailure = (params: IFetchChecklistTemplatesParams) =>
  action(AccountActionsEnum.ACCOUNT_CHECKLIST_TEMPLATES_GET_FAILURE, {
    params,
  });

export const accountRequirementTemplatesGet = (params: IAccountRequirementTemplatesGetParams) =>
  action(AccountActionsEnum.ACCOUNT_REQUIREMENT_TEMPLATES_GET, { params });
export const accountRequirementTemplatesGetRequest = (params: IFetchRequirementTemplatesParams) =>
  action(AccountActionsEnum.ACCOUNT_REQUIREMENT_TEMPLATES_GET_REQUEST, { params });
export const accountRequirementTemplatesGetSuccess = (
  params: IFetchRequirementTemplatesParams,
  data: IPageRequirementsTemplate,
) =>
  action(AccountActionsEnum.ACCOUNT_REQUIREMENT_TEMPLATES_GET_SUCCESS, {
    params,
    data,
  });
export const accountRequirementTemplatesGetFailure = (params: IFetchRequirementTemplatesParams) =>
  action(AccountActionsEnum.ACCOUNT_REQUIREMENT_TEMPLATES_GET_FAILURE, {
    params,
  });

export const accountOrganizationsWithDistrictGet = () =>
  action(AccountActionsEnum.ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET);
export const accountOrganizationsWithDistrictGetRequest = () =>
  action(AccountActionsEnum.ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET_REQUEST);
export const accountOrganizationsWithDistrictGetSuccess = (data: IUserOrganisationsResponse) =>
  action(AccountActionsEnum.ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET_SUCCESS, {
    data,
  });
export const accountOrganizationsWithDistrictGetFailure = () =>
  action(AccountActionsEnum.ACCOUNT_ORGANIZATIONS_WITH_DISTRICT_GET_FAILURE);

export const accountOrganizationsGet = () => action(AccountActionsEnum.ACCOUNT_ORGANIZATIONS_GET);
export const accountOrganizationsGetRequest = () => action(AccountActionsEnum.ACCOUNT_ORGANIZATIONS_GET_REQUEST);
export const accountOrganizationsGetSuccess = (data: IUserOrganisationsResponse) =>
  action(AccountActionsEnum.ACCOUNT_ORGANIZATIONS_GET_SUCCESS, {
    data,
  });
export const accountOrganizationsGetFailure = () => action(AccountActionsEnum.ACCOUNT_ORGANIZATIONS_GET_FAILURE);
export const accountOrganizationsReset = () => action(AccountActionsEnum.ACCOUNT_ORGANIZATIONS_RESET);
export const accountKnoOrganizationFunctionsGet = (params: IAccountKnoOrganizationFunctionsGetParams) =>
  action(AccountActionsEnum.ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET, { params });
export const accountKnoOrganizationFunctionsGetRequest = (knoOrganizationId: string) =>
  action(AccountActionsEnum.ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET_REQUEST, { knoOrganizationId });
export const accountKnoOrganizationFunctionsGetSuccess = (
  knoOrganizationId: string,
  data: IKnoOrganisationFunction[],
) =>
  action(AccountActionsEnum.ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET_SUCCESS, {
    knoOrganizationId,
    data,
  });
export const accountKnoOrganizationFunctionsGetFailure = (knoOrganizationId: string) =>
  action(AccountActionsEnum.ACCOUNT_KNO_ORGANIZATION_FUNCTIONS_GET_FAILURE, {
    knoOrganizationId,
  });
